/**
 * @function FactoracionForm
 * @description A React component to render a Hubspot Form for factorization.
 * @param {Object} props - The properties object.
 * @param {string} props.classWidth - The CSS class defining the width of the container.
 * @example
 *   <FactoracionForm classWidth="w-full" />
 * @returns {ReactElement} Returns the Hubspot Form wrapped in a styled div.
 */
// import HubspotForm from 'react-hubspot-form';

export default function FactoracionForm({classWidth}) {
  return (
    <>
      <div className={classWidth}>
        <div className="mx-auto p-5 border-gray-80 border bg-gray-60 rounded-xl flex flex-col pt-8 px-8 pb-4 xs:px-4 mayoreo-form">
          <h2 className="section-title  xs:text-center xs:px-0 xs:mb-3 hidden"></h2>
          <iframe
            className="transparent-iframe"
            allowTransparency="true"
            src="https://cloud.mkt-ellibrero.com/Ventas_Mayoreo_El_Librero"
            allowFullScreen
          />
          {/* <HubspotForm
            portalId="6438710"
            formId="fe0f250e-e3e4-4b83-94ca-9f8824774695"
            onSubmit={() => console.log('Enviar!')}
            onReady={(form) => console.log('Wholesale ready!')}
            loading={<div>Loading...</div>}
          /> */}
        </div>
      </div>
    </>
  );
}
